import React from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom'; // Import navigation

const GenericEventList = ({ itemType, title, data, onEdit, onDelete, showNumberOfDays = false }) => {
  const navigate = useNavigate();

  const filteredItems = data
    .slice()
    .sort((a, b) => moment(a.start_date).valueOf() - moment(b.start_date).valueOf());

  const showDateOnly = itemType === 'awareness' || itemType === 'celebration';
  const showFullDetails = !showDateOnly;

  return (
    <div className="">
      {filteredItems.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>S.No.</th>
                {showNumberOfDays && <th>No. of Days</th>}
                <th>Name</th>
                <th>{showDateOnly ? 'Date' : 'Start Date'}</th>
                {showFullDetails && <th>End Date</th>}
                {/* {showFullDetails && <th>Time</th>} */}
                {/* {showFullDetails && <th>Description</th>} */}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredItems.map((item, index) => {
                const start = moment(item.start_date);
                const end = moment(item.end_date);
                const numberOfDays = end.diff(start, 'days') + 1;

                return (
                  <tr key={item.id || index}>
                    <td>{index + 1}</td>
                    {showNumberOfDays && <td>{numberOfDays}</td>}
                    <td>
                      {/* Modified section: Apply click handling for both awareness and celebration */}
                      {(itemType === 'awareness' || itemType === 'celebration') ? (
                        <span
                          style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
                          onClick={() => {
                            if (itemType === 'awareness') {
                              navigate(`/awareness-details/${item.awareness_id || item.id}`);
                            } else if (itemType === 'celebration') {
                              sessionStorage.setItem('celebrations.subTab', 'list');
                              navigate(`/celebration-details/${item.celebration_id}`); // Assuming item.date or item.id for celebrations
                            }
                          }}
                        >
                          {item.details || item.name}
                        </span>
                      ) : (
                        item.details || item.name
                      )}
                      {/* {itemType === 'awareness' || itemType === 'celebration' && (
                        <i
                          className="fa fa-eye ms-2"
                          style={{ cursor: 'pointer', color: '#555' }}
                          title="View details"
                          onClick={() => {
                            // Future functionality can be added here
                            console.log('Eye icon clicked for:', item.id || item.name);
                          }}
                        ></i>
                      )} */}
                    </td>
                    <td>{start.format('DD MMMM YYYY')}</td>
                    {showFullDetails && <td>{end.format('DD MMMM YYYY')}</td>}
                    {/* {showFullDetails && (
                      <td>
                        {item.start_time || item.end_time
                          ? `${item.start_time || ''}${item.start_time && item.end_time ? '-' : ''}${item.end_time || ''}`
                          : 'N/A'}
                      </td>
                    )} */}
                    {/* {showFullDetails && <td>{item.description || item.details || 'N/A'}</td>} */}
                    <td>
                      <button className="btn btn-sm btn-warning me-2" onClick={() => onEdit(item)}>
                        Edit
                      </button>
                      <button className="btn btn-sm btn-danger" onClick={() => onDelete(item.id)}>
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="alert alert-info" role="alert">
          No {title.toLowerCase()} added yet.
        </div>
      )}
    </div>
  );
};

export default GenericEventList;